
import { AudioGraph } from "../AudioGraph";
import { AudioGraphNodeType } from "../AudioGraphNodeType";
import { AudioGraphNode } from "./AudioGraphNode";

export class Gain extends AudioGraphNode<GainNode>
{
  constructor( graph:AudioGraph, id:number )
  {
    super( graph, id, AudioGraphNodeType.Gain );
  }

  protected _assignAudioNode()
  {
    this._node = this._context.createGain();
  }
}